import { MenuHeader, MenuItem } from '../../private/shared/models/menu-item';
import { IStatus, ISummaryPrice } from '../../private/shared/models/productos';
import { AppRoutes } from '../app-routes';
import { AnalyticsEventType, EAnalyticsPageViews } from '../enums/analytics.enum';
import { AppSettings } from './../../app.settings';
import { IObjecBanner, IObjectDataLayerInteraction } from './Analytics';
import { IBottleLoading, IGenericError } from './Error';
import { IRequestEndpoint } from './request.model';


export const NO_GUARDS = [
    '/home'
    , '/login'
    , '/contenido-cliente'
    , '/registro/registro'
    , '/registro/recuperacion'
    , '/perfil-registro'
    , '/ReseteoUsuario'
]

export const SHOP_URLS = [
    '/Tienda'
    , '/Carrito'
    , '/ResumenPedido'
    , '/Promociones'
    , '/Productos'
    , '/Orden'
    , '/MisPedidos'
    , '/Confirmacion'
]

// TODO: Modifcar cuando sean las url's finales
export const ECOMMERCE_V2_URLS = [
    'Tienda'
    , 'Carrito'
    , 'Confirmacion'
    , `/${AppRoutes.PRODUCT_DETAIL}/`
    , `/${AppRoutes.PROMO_DETAIL}/`
]

export const URLS_SENDCART = [
    '/Tienda'
    , '/main/Tienda'
    , '/Productos'
    , '/Promociones'
    , '/PedidoInteligente'
    , '/Recomendados'
];

export const UPDATE_CART_URL_ONPAUSE = [
    '/Carrito'
]

export const URLS_IGNORE_DESKTOP = [
    '/eliminar-cuenta'
];

export const URLS_GAMES = [
    'Juegos'
    , 'Load-Game'
    , 'Leaderboard'
];

export const SEARCH_DEBOUNCE_TIME = 500;

export const CloudFunctionsProgrammes = [
    {
        ID_Programa: 1
        , store: 'cf_spS_ObtieneCDGTendero'
    }
    , {
        ID_Programa: 2
        , store: 'cf_spS_ObtieneGJCPTendero'
    }
    , {
        ID_Programa: 3
        , store: 'cf_spS_ObtieneGJCPTendero'
    }
]

export const BottleLoading: IBottleLoading = {
    message: '<div class="margenes"><img src="./assets/common/bottle.svg" alt="" class="botella-loading"></div>'
        + '<div class="margenes"><ion-spinner name="dots" class="loading"></ion-spinner></div>'
        + '<div class="margenes"><p class="cargando">Cargando…</p></div>'
    , spinner: null
    , cssClass: 'ion-loading'
    , showBackdrop: true
}

export const TypesErrors: IGenericError = {
    WithoutInternet: {
        image: './assets/empty-data/no-network.svg'
        , title: 'Sin internet'
        , description: 'Comprueba tu conexión y vuelve a intentarlo'
        , analyticScreen: 'errorWithoutInternetView'
    },
    NoData: {
        image: './assets/empty-data/no-data.svg'
        , title: 'Sin datos'
        , description: 'No hemos encontrado información'
        , analyticScreen: 'errorNoDataView'
    },
    WeHaveDifficulties: {
        image: './assets/empty-data/general-error.svg'
        , title: 'Tenemos dificultades'
        , description: 'Estamos trabajando, ya casi terminamos'
        , analyticScreen: 'errorWeHaveDifficultiesView'
    }
}

export const Authentication = {
    ResetearUsuario: 'ResetearUsuario'
}

export const NativeStorageNamesV2 = {
    BodegaNud: 'BodegaNud'
    , ArrayMenu: 'ArrayMenu'
    , TicketPromedio: 'TicketPromedio'
    , ProgramaTenderos: 'ProgramaTenderos'
    , UltimoPortafolio: 'UltimoPortafolio'
    , PerfilUsuario: 'PerfilUsuario'
    , ArrayTask: 'ArrayTask'
    , Timer: 'Timer'
    , CameraPreview: 'CameraPreview'
    , FechasEjecucion: 'FechasEjecucion'
    , ContenidoClientes: 'contenidoClientes'
    , OverlaysModulos: 'OverlaysModulos'
    , InicioApp: 'InicioApp'
    , ToastEjecucion: 'ToastEjecucion'
    , ComprasMes: 'ComprasMes'
    , ComprasDiasSem: 'ComprasDiasSem'
    , ComprasTickets: 'ComprasTickets'
    , TerminosCondiciones: 'TerminosCondiciones'
    , AvisoPrivacidad: 'AvisoPrivacidad'
    , LegacyChange: 'LegacyChange'
    , GrowMore: 'CreceMas'
    , TokenPremiados: 'TokenPremiados'
    , UltimaFechaConsultPremiados: 'UltimaFechaConsultPremiados'
    , PuntosPremiados: 'PuntosPremiados'
    , butonSMS: 'butonSMS'
    , CartOrderState: 'CartOrderState'
    , ObtienePromocionesEcommerce: 'ObtienePromocionesEcommerce'
    , Resumen: 'Gamificacion/Resumen'
    , Cuotas: 'Gamificacion/Cuotas'
    , ObtieneOpcionesAsistencia: 'GetAssistanceOptions'
    , ObtenerSeccionesPremiados: 'ObtenerSeccionesPremiados'
    , PlatformOrigin: 'PlatformOrigin'
    , CartItemsAnalytics: 'CartItemsAnalytics'
    , LastAnalyticsOrigin: 'LastAnalyticsOrigin'
    , SesionRegistroImpulsaGepp: 'SesionRegistroImpulsaGepp'
    , RecentSearches: 'RecentSearches'
}

// ***** NOTA: Eliminar aquellos que vaya migrando
export const GETS = {
    ObtieneProgramaTendero: 'ObtieneProgramaTendero',
    ObtienePromocionesTendero: 'ObtienePromocionesTendero',
    ObtieneUltimoPortafolio: 'ObtieneUltimoPortafolio',
    ObtieneNoticiasTendero: 'ObtieneNoticiasTendero',
    ObtieneNotificacionTendero: 'ObtieneNotificacionTendero',
    ActualizaNotificacionTendero: 'ActualizaNotificacionTendero',
    ObtUsrProfile: 'ObtUsrProfile',
    ValidaContrasenaActual: 'ValidaContrasenaActual',
    LogErrorSms: 'LogErrorSms',
    ObtieneResultadosEjecucion: 'ObtieneResultadosEjecucion',
    ObtieneTerminosCondiciones: 'ObtieneTerminosCondiciones',
    ObtieneAvisoPrivacidad: 'ObtieneAvisoPrivacidad',
    ActualizaLegalVersionUsuario: 'ActualizaLegalVersionUsuario',
    SendOrderWebhook: 'ProvidersEcommerce/SendOrderWebhook',
    ValidatedJwtWaUser: 'ProvidersUsers/ValidatedJwtWaUser',
    AuthUserPhone: 'ProvidersUsers/AuthUserPhone',
    Resumen: 'Gamificacion/Resumen',
    Autoevaluacion: 'Gamificacion/Autoevaluacion',
    Cuotas: 'Gamificacion/Cuotas',
    ObtenerTokenPremiados: 'ObtenerTokenPremiados',
    ObtenerSeccionesPremiados: 'ObtenerSeccionesPremiados',
}

export const PUSHNOTIFCATIONS_ENDPOINTS = {
    get_notifications: {
        method: 'get',
        url: '/api-push-module/v1/notifications/user',
        headers: {}
    } as IRequestEndpoint,
    patch_notifications_view: {
        method: 'patch',
        url: '/api-push-module/v1/notifications/user/view',
        headers: {}
    } as IRequestEndpoint,
    post_push_permissions: {
        method: 'post',
        url: '/autentificacion/v1/device/push-permissions',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    put_fcm_token: {
        method: 'put',
        url: '/autentificacion/v1/device/fcm-token',
        headers: {}
    } as IRequestEndpoint,
}

// FCM (Firebase Cloud Messaging) Constants
export const FCM_INVALID_TOKEN_ERRORS = [
    'messaging/registration-token-not-registered',
    'messaging/invalid-registration-token',
    'messaging/mismatched-credential',
    'NotRegistered',
    'InvalidRegistration'
] as const

export const ECOMMERCE_ENDPOINTS = {
    get_products: {
        method: 'post',
        url: '/ecommerce/v2/products',
        headers: {}
    } as IRequestEndpoint,
    get_promos: {
        method: 'post',
        url: '/ecommerce/v2/promotions',
        headers: {}
    } as IRequestEndpoint,
    get_orders_v3: {
        method: 'post',
        url: '/ecommerce/v3/orders',
        headers: {}
    } as IRequestEndpoint,
    get_historical_orders: {
        method: 'post',
        url: '/ecommerce/v3/historical-orders',
        headers: {}
    } as IRequestEndpoint,
    get_configuration_ecommerce: {
        method: 'post',
        url: '/ecommerce/v3/configuration-ecommerce',
        headers: {}
    } as IRequestEndpoint,
    get_order_detail: {
        method: 'post',
        url: '/ecommerce/v2/order/details',
        headers: {}
    } as IRequestEndpoint,
    cancel_order: {
        method: 'post',
        url: '/ecommerce/v2/order/cancel',
        headers: {}
    } as IRequestEndpoint,
    create_cart: {
        method: 'post',
        url: '/ecommerce/v3/cart/create',
        headers: {}
    } as IRequestEndpoint,
    send_order: {
        method: 'post',
        url: '/ecommerce/v2/order/send',
        headers: {}
    } as IRequestEndpoint,
    get_tienda: {
        method: 'post',
        url: '/ecommerce/v3/tienda',
        headers: {}
    } as IRequestEndpoint,
};

export const AUTENTIFICACION_ENDPOINTS = {
    get_register_validate: {
        method: 'get',
        url: '/autentificacion/v1/register/validate',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    get_flow_counter: {
        method: 'get',
        url: '/autentificacion/v1/flow-counter',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_flow_counter: {
        method: 'post',
        url: '/autentificacion/v1/flow-counter',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_create_code: {
        method: 'post',
        url: '/autentificacion/v1/create-code',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_update_code: {
        method: 'post',
        url: '/autentificacion/v1/update-code',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_login: {
        method: 'post',
        url: '/autentificacion/v1/user-app/login',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_register: {
        method: 'post',
        url: '/autentificacion/v1/user-app/register',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_refresh_auth_token: {
        method: 'post',
        url: '/autentificacion/v1/user-app/refresh-token',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    put_update_profile: {
        method: 'put',
        url: '/autentificacion/v2/user/update-profile',
        headers: {}
    } as IRequestEndpoint,
    put_cancel_account: {
        method: 'put',
        url: '/autentificacion/v2/user/cancel-account',
        headers: {}
    } as IRequestEndpoint,
    put_update_password: {
        method: 'put',
        url: '/autentificacion/v1/user/update-password',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_validate_token_bo: {
        method: 'post',
        url: '/autentificacion/v1/tendero/validate-token',
        headers: {}
    } as IRequestEndpoint,
    post_user_info: {
        method: 'post',
        url: '/autentificacion/v1/user-app/user-info',
        headers: {}
    } as IRequestEndpoint,
}

export const TENDERO_ENDPOINTS = {
    get_popup_status: {
        method: 'get',
        url: '/api-tenderos/v1/popup-status',
        headers: {}
    } as IRequestEndpoint,
    post_tendero_popup: {
        method: 'post',
        url: '/api-tenderos/v1/tendero-popup',
        headers: {}
    } as IRequestEndpoint,
    get_rn_login_url: {
        method: 'post',
        url: '/api-tenderos/v1/get-rn-login-url',
        headers: {}
    } as IRequestEndpoint,
    get_legal_version: {
        method: 'get',
        url: '/api-tenderos/v1/loyalty-program/get-legal-version',
        headers: {}
    } as IRequestEndpoint,
    update_legal_version: {
        method: 'post',
        url: '/api-tenderos/v1/loyalty-program/update-legal-version',
        headers: {}
    } as IRequestEndpoint,
    get_general_data: {
        method: 'get',
        url: '/api-programa-lealtad/v1/loyalty-program/getGeneralData',
        headers: {}
    } as IRequestEndpoint,
    get_movements: {
        method: 'get',
        url: '/api-programa-lealtad/v1/loyalty-program/getMovements',
        headers: {}
    } as IRequestEndpoint,
}

export const CAMBIOS_MERCADO_ENDPOINTS = {
    get_catalogo: {
        method: 'get',
        url: '/ecommerce/v1/market-change/products',
        headers: {}
    } as IRequestEndpoint,
    get_reasons: {
        method: 'get',
        url: '/ecommerce/v1/market-change/reasons',
        headers: {}
    } as IRequestEndpoint,
    create_ticket: {
        method: 'post',
        url: '/ecommerce/v1/market-change',
        headers: {}
    } as IRequestEndpoint,
    cancel_ticket: {
        method: 'delete',
        url: '/ecommerce/v1/market-change',
        headers: {}
    } as IRequestEndpoint,
    get_ticket_activo: {
        method: 'get',
        url: '/ecommerce/v1/market-change/active',
        headers: {}
    } as IRequestEndpoint,
    update_ticket: {
        method: 'put',
        url: '/ecommerce/v1/market-change',
        headers: {}
    } as IRequestEndpoint,
}

export const GAMIFICACION_ENDPOINTS = {
    get_list_games: {
        method: 'get',
        url: '/games/GetListGames',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_add_game_history: {
        method: 'post',
        url: '/games/AddGameHistory',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_status_lifes: {
        method: 'post',
        url: '/games/GetStatusLifes',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_leaderboard: {
        method: 'post',
        url: '/games/Leaderboard',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_leaderboard_by_game: {
        method: 'post',
        url: '/games/LeaderboardByGame',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_save_connection: {
        method: 'post',
        url: '/games/SaveConnection',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_set_status_lifes: {
        method: 'post',
        url: '/games/SetStatusLifes',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_started_game: {
        method: 'post',
        url: '/games/StartedGame',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_user_info_games: {
        method: 'post',
        url: '/games/UserInfoGames',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
}

export const EJECUCION_ENDPOINTS = {
    get_self_assessment_results: {
        method: 'get',
        url: '/api-tenderos/v1/self-assessment/results',
        headers: {}
    } as IRequestEndpoint,
    post_save_execution_incidence: {
        method: 'post',
        url: '/api-tenderos/v1/self-assessment/incidencia',
        headers: {}
    } as IRequestEndpoint,
    post_get_execution_config: {
        method: 'get',
        url: '/api-tenderos/v1/self-assessment/autoevaluacion',
        headers: {}
    } as IRequestEndpoint,
    post_upload_execution: {
        method: 'post',
        url: '/api-tenderos/v1/self-assessment/upload',
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    } as IRequestEndpoint,
}

export const GESTION_CONTENIDO_ENDPOINTS = {
    post_update_user_legal_version: {
        method: 'post',
        url: '/politicas/actualizaLegalVersionUsuario',
        headers: {}
    } as IRequestEndpoint,
    post_program_contact: {
        method: 'post',
        url: '/programa-tendero/contactoPrograma',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_customer_content: {
        method: 'post',
        url: '/consumidor/contenidoClientesV1',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_rate_our_answer: {
        method: 'post',
        url: '/calificanos-tendero/insertRespuestaCalificanos',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_get_mural_data: {
        method: 'post',
        url: '/mural/ObtenerDatosMural',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_get_privacy_notice: {
        method: 'post',
        url: '/politicas/obtieneAvisoPrivacidad',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_get_execution_config: {
        method: 'post',
        url: '/configuracion/obtieneConfiguracion',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_get_contact_info: {
        method: 'post',
        url: '/calificanos-tendero/ObtieneContactoCalificanos',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_get_inicio_app: {
        method: 'post',
        url: '/inicio-app/obtieneInicioApp',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_get_mechanics_program: {
        method: 'post',
        url: '/dinamica-tendero/obtieneMecanicaPrograma',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_get_terms_and_conditions: {
        method: 'post',
        url: '/politicas/obtieneTerminosCondiciones',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_get_questions: {
        method: 'post',
        url: '/calificanos-tendero/ObtPreguntasCalificanos',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
}

export const GESTION_USUARIOS_ENDPOINTS = {
    post_get_user_profile: {
        method: 'post',
        url: '/perfil-tendero/obtUsrProfile',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    authenticates_phone_retailer: {
        method: 'post',
        url: '/authentications/autentificaTelefonoDetallista',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    user_reset: {
        method: 'post',
        url: '/reseteo-usuarios/resetearUsuario',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    validate_current_password: {
        method: 'post',
        url: '/perfil-validaciones/validaContrasenaActual',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint
}

// ? Llaves del storage que se deben de borrar al cerrar sesión
export const DATA_STORAGE_KEYS = [
    ECOMMERCE_ENDPOINTS.get_tienda.url,
    ECOMMERCE_ENDPOINTS.get_products.url,
    NativeStorageNamesV2.BodegaNud,
    NativeStorageNamesV2.PerfilUsuario,
    NativeStorageNamesV2.ProgramaTenderos,
    NativeStorageNamesV2.TicketPromedio,
    NativeStorageNamesV2.UltimaFechaConsultPremiados,
    NativeStorageNamesV2.UltimoPortafolio,
    NativeStorageNamesV2.PuntosPremiados,
    NativeStorageNamesV2.TokenPremiados,
    NativeStorageNamesV2.ObtienePromocionesEcommerce,
    NativeStorageNamesV2.Resumen,
    NativeStorageNamesV2.ObtieneOpcionesAsistencia,
    NativeStorageNamesV2.Cuotas,
    NativeStorageNamesV2.ObtenerSeccionesPremiados,
    NativeStorageNamesV2.ArrayTask,
    NativeStorageNamesV2.CameraPreview,
    NativeStorageNamesV2.ToastEjecucion,
    NativeStorageNamesV2.SesionRegistroImpulsaGepp,
    AppSettings.JWT_L,
    NativeStorageNamesV2.CartItemsAnalytics,
    NativeStorageNamesV2.LastAnalyticsOrigin,
    AppSettings.PEDIDO_ANALYTICS,
    NativeStorageNamesV2.RecentSearches,
];

export const CRECE_MAS_ENDPOINTS = {
    post_obtiene_dashboard: {
        method: 'post',
        url: '/crece-mas/obtieneDashboard',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_sesion_registro: {
        method: 'post',
        url: '/crece-mas/sesionRegistro',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_cerrar_sesion: {
        method: 'post',
        url: '/crece-mas/cerrarSesion',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_resolver_url: {
        method: 'post',
        url: '/crece-mas/resolverUrl',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
}

export const IMPULSA_GEPP_ENDPOINTS = {
    post_sesion_registro: {
        method: 'post',
        url: '/impulsa-gepp/sesionRegistro',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_actualiza_telefono: {
        method: 'post',
        url: '/impulsa-gepp/actualizaTelefono',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
}

export const PREMIADOS_ENDPOINTS = {
    post_obtener_token: {
        method: 'post',
        url: '/premiados/obtenerToken',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_obtener_secciones: {
        method: 'post',
        url: '/premiados/obtenerSecciones',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
}

export const GESTION_TICKETS_ENDPOINTS = {
    post_calcula_ticket_promedio_v2: {
        method: 'post',
        url: '/programa-tendero/calculaTicketPromedioV2',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    get_assistance_options: {
        method: 'get',
        url: '/asistencia/GetAssistanceOptions',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_obtiene_ventas_dias_sem_historico_tendero: {
        method: 'post',
        url: '/historico-ventas/obtieneVentasDiasSemHistoricoTendero',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_obtiene_ventas_historico_tickets_tendero: {
        method: 'post',
        url: '/historico-ventas/obtieneVentasHistoricoTicketsTendero',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_obtiene_ventas_mes_historico_tendero: {
        method: 'post',
        url: '/historico-ventas/obtieneVentasMesHistoricoTendero',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_save_assistance: {
        method: 'post',
        url: '/asistencia/SaveAssistance',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint,
    post_obtiene_ventas_new_tickets_tendero: {
        method: 'post',
        url: '/historico-ventas/obtieneVentasNewTicketsTendero',
        headers: { Authorization: 'none' }
    } as IRequestEndpoint
}


// ? Llaves del storage que no deben encriptar
export const KEY_IGNORE_ENCRYP: Record<string, boolean> = {
    [AppSettings.JWT_L]: true,
    [NativeStorageNamesV2.PlatformOrigin]: true
};

// ? Prefijos de llaves dinámicas del storage que no deben encriptar
export const PREFIX_IGNORE_ENCRYP: string[] = [
    'tracked_favs_finished_'
];

export const OVERLAYS = {
    LOGIN: 'LOGIN',
    COMPRAS: 'COMPRAS',
    PRODUCTOS: 'PRODUCTOS',
    PEDIDOS: 'PEDIDOS',
    Mural: 'Mural'
}

export const ReplaceMessageV2 = '{{message}}';

export const PasswordUpdate: IBottleLoading = {
    message: `<p class="title-alert"><b>Contraseña actualizada</b><p>
        <div class="icon-warning"><ion-icon id="success" name="checkmark-circle-outline"></ion-icon></div><br>
        <div class="p-alert-message"><p>Por seguridad, deberás ingresar nuevamente con tus nuevos datos</p></div>`,
    spinner: 'Aceptar',
    cssClass: 'alert-notification',
    showBackdrop: false
};

export const UserAlreadyExistsPerfil: IBottleLoading = {
    message: `<div class="icon-warning"><ion-icon id="info" name="information-circle-outline"></ion-icon></div><br>
        <div class="p-alert-message"><p>Lo sentimos, este usuario ya fue previamente registrado.</p></div>`,
    spinner: 'LOGIN',
    cssClass: 'alert-notification',
    showBackdrop: false
};

export const messageAlertNotFound: IBottleLoading = {
    message: `<div class="icon-warning"><ion-icon name="warning"></ion-icon></div>
        <br><div class="p-alert-message"><p>{{message}}</p></div>`,
    spinner: 'Aceptar',
    cssClass: 'alert-notification',
    showBackdrop: false
};

export const userAlreadyExists: IBottleLoading = {
    message: `<div class="icon-warning"><ion-icon id="info" name="information-circle-outline"></ion-icon></div><br>
        <div class="p-alert-message"><p>{{message}}</p></div>`,
    spinner: 'Aceptar',
    cssClass: 'alert-notification',
    showBackdrop: false
};

export const genericMessage = '<div class="p-warning-no-encontrado"><p>{{ message }}</p></div>'

export const blockedAllRequests: IBottleLoading = {
    message: `<div class="icon-warning"><ion-icon name="warning"></ion-icon></div>
        <br><div class="p-alert-message">
        <p>Este número de teléfono ha excedido el límite de solicitudes, espera 24 horas para reintentar.</p></div>`,
    spinner: 'Aceptar',
    cssClass: 'alert-notification',
    showBackdrop: false
};

export const SmsCodeError: IBottleLoading = {
    message: `<div class="icon-warning"><ion-icon id="warning" name="warning-outline"></ion-icon></div>
        <br><div class="p-alert-message"><p>El código es incorrecto
        <br>Revisa e inténtalo nuevamente</p></div>`,
    spinner: 'Aceptar',
    cssClass: 'alert-notification',
    showBackdrop: false
};

export const EnterYourNewPassword = '<div class="p-warning-no-encontrado"><p>Ingresa tu nueva contraseña</p>'
    + '<p class="tu-contrasena">Tu contraseña debe de ser de 8 a 12 caracteres, incluye por lo menos una letra mayúscula '
    + 'y un número.</p></div>'

export const loadingRecovery = '<div class="p-warning-no-encontrado"><p>Estamos actualizando tus datos</p>'
    + '<p class="p-warning-no-encontrado">Espera un momento...</p></div>'

export const WarninLogin: IBottleLoading = {
    message: `<div class="icon-warning"><ion-icon id="warning" name="warning-outline"></ion-icon></div>
        <br><div class="p-alert-message"><p>¡Lo sentimos!<br>
        No pudimos procesar tu petición, vuelve a intentarlo más tarde</p></div>`,
    spinner: 'Aceptar',
    cssClass: 'alert-notification',
    showBackdrop: false
};

export const messageAlertCreationOrder: IBottleLoading = {
    message: `<div class="icon-warning"><ion-icon id="warning" name="warning-outline"></ion-icon></div>
        <br><div class="p-alert-message"><p>¡Lo sentimos!<br>
        No pudimos procesar tu pedido, vuelve a intentarlo más tarde</p></div>`,
    spinner: 'Aceptar',
    cssClass: 'alert-notification',
    showBackdrop: false
};

export const ErrorServer: IBottleLoading = {
    message: `<div class="icon-warning"><ion-icon id="warning" name="warning-outline"></ion-icon></div><br><div class="p-alert-message"><p>¡Oops!... hubo un problema</p><p>Algo salió mal al conectarnos con el servidor.<br>Intenta de nuevo en un momento.<br>¡Gracias por tu paciencia!</p></div>`,
    spinner: 'Cerrar',
    cssClass: 'alert-error',
    showBackdrop: true
};

export const CloseSesion: IBottleLoading = {
    message: `<div class="icon-warning"><ion-icon id="friendly" name="lock-closed-outline"></ion-icon></div><br><div class="p-alert-message"><p>¡Atención!</p><p>Por seguridad, tu sesión se cerrará en breve. Por favor, inicia sesión nuevamente.</p></div>`,
    spinner: 'Aceptar',
    cssClass: 'alert-friendly',
    showBackdrop: true
};

export const PermissionCall = '<div class="labels-permission-call"> <div> <ion-icon name="call"></ion-icon> \
    </div> <div> <p class="header"><b>Lo sentimos, no puedes usar GETM sin este permiso.</b></p> \
    <p class="message">Vaya a Configuraci&oacute;n -&gt; Aplicaciones -&gt; GETM para otorgar los permisos requeridos.</p> </div></div>'

/**
 * Enum para los IDs de las solapas de la tienda (getm-ecommerce)
 * Centraliza las referencias a los tabs para evitar números mágicos
 */
export enum EcommerceTabId {
    FAVORITOS = 1,
    PROMOCIONES = 2,
    TENDENCIAS = 3,
    CATEGORIAS = 4,
}


export const MenuTabs: MenuItem[] = [
    {
        "id": 1,
        "tab": "Compras",
        "title": "Historial",
        "iconUrl": "compras",
        "itemclass": "icon",
        "idRouter": 2,
        "route": "/main/Compras",
        "screenName": "Compras",
        "header": "Mi Historial",
        "principal": 0
    },
    {
        "id": 2,
        "tab": "Mural",
        "title": "Para Ti",
        "iconUrl": "por-ti-icon",
        "itemclass": "icon",
        "idRouter": 6,
        "route": "/main/Mural",
        "screenName": "Para Ti",
        "header": "Para Ti",
        "principal": 1
    },
    {
        "id": 4,
        "tab": "Mas",
        "title": "Más",
        "iconUrl": "mas-icon",
        "itemclass": "icon",
        "idRouter": 13,
        "route": "/main/Mas",
        "screenName": "Mas",
        "header": "Más",
        "principal": 0
    }
];

export const MenuTabsHamburger = [
    {
        id: 1,
        tab: 'Tienda',
        title: 'Tienda',
        iconUrl: 'pedidos',
        itemclass: 'icon',
        screenName: 'Tienda',
        header: 'Tienda'
    },
    {
        id: 4,
        tab: 'Compras',
        title: 'Historial',
        iconUrl: 'compras',
        itemclass: 'icon',
        screenName: 'Compras',
        header: 'Mi Historial'
    },
    {
        id: 5,
        tab: 'Mural',
        title: 'Para Ti',
        iconUrl: 'por-ti-icon',
        itemclass: 'icon',
        screenName: 'Para Ti',
        header: 'Para Ti'
    }
]

export const MenuMas: Array<MenuItem> = [
    {
        id: 1,
        tab: 'perfil',
        title: 'Mi perfil',
        iconUrl: '../../../../assets/icon/user-icon-gray.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'mi_perfil',
        active: true
    },
    {
        id: 2,
        tab: 'Noticias',
        title: 'Noticias',
        iconUrl: '../../../../assets/icon/news-icon.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'noticias',
        active: true
    },
    {
        id: 3,
        tab: 'Califica',
        title: 'Califícanos',
        iconUrl: '../../../../assets/icon/rate-icon-gray.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'calificanos',
        active: true
    },
    {
        id: 4,
        tab: 'Contacto',
        title: 'Línea de contacto',
        iconUrl: '../../../../assets/icon/call-icon-gray.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'linea_de_contacto',
        active: true
    },
    {
        id: 6,
        tab: 'home',
        title: 'Cerrar sesión',
        iconUrl: '../../../../assets/icon/exit-icon-gray.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'cerrar_sesion',
        active: true
    },
    {
        id: 7,
        tab: 'Terminos',
        title: 'Aviso de Privacidad',
        iconUrl: '../../../../assets/icon/document-icon-gray.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'aviso_de_privacidad',
        active: true
    }
]

export const MenuMasHamburger: Array<MenuItem> = [
    {
        id: 1,
        tab: 'perfil',
        title: 'Mi perfil',
        iconUrl: '../../../../assets/icon/user-icon-gray.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'mi_perfil'
    },
    {
        id: 2,
        tab: 'Noticias',
        title: 'Noticias',
        iconUrl: '../../../../assets/icon/news-icon.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'noticias'
    },
    {
        id: 3,
        tab: 'Califica',
        title: 'Califícanos',
        iconUrl: '../../../../assets/icon/rate-icon-gray.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'calificanos'
    },
    {
        id: 4,
        tab: 'Contacto',
        title: 'Línea de contacto',
        iconUrl: '../../../../assets/icon/call-icon-gray.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'linea_de_contacto'
    },
    {
        id: 6,
        tab: 'Terminos',
        title: 'Aviso de Privacidad',
        iconUrl: '../../../../assets/icon/document-icon-gray.svg',
        data_categoria: 'menu',
        data_accion: '/Mas',
        data_etiqueta: 'aviso_de_privacidad'
    }
]

export const MENUHEADER: Array<MenuHeader> = [
    {
        id: 10,
        tab: 'notificationes',
        title: 'Notificationes',
        route: '/Notificationes',
        iconUrl: './assets/icon/bell-icon.svg',
        itemclass: 'icon-bell',
        active: true
    },
    {
        id: 20,
        tab: 'juegos',
        title: 'Juegos',
        route: '/Juegos',
        iconUrl: './assets/icon/icon-games-multicolor.svg',
        itemclass: 'icon-gaming',
        active: false
    },
    {
        id: 30,
        tab: 'Impulsa-GEPP',
        title: 'Impulsa GEPP',
        route: '/Impulsa-GEPP',
        iconUrl: './assets/icon/impulsa_gepp_multicolor.svg',
        itemclass: 'icon-enko',
        active: false
    }
];

export const INPUTTYPES = {
    1: 'password',
    2: 'phone_number',
    3: 'sms'
}

export const DEFAULT_INICIO_HOME: IHome = {
    Titulo: '¡Bienvenido a Gepp!'
    , Subtitulo: 'Nos gustaría saber más de ti'
    , Imagen_1: './assets/icons-home/detallista@3x.png'
    , Ingreso_1: '¿Vendes productos GEPP?'
    , Tamanio_Imagen_1: 'big'
    , Separador: '&oacute;'
    , Imagen_2: './assets/icons-home/consumidor@3x.png'
    , Ingreso_2: '¿Eres consumidor?'
    , Tamanio_Imagen_2: 'small'
}

export const DEFAULT_RECOMMENDED = [
    {
        "Modelo": 2,
        "Recomendador": "Promociones",
        "Prioridad": 30
    },
    {
        "Modelo": null,
        "Recomendador": "General",
        "Prioridad": 40
    }
];

export interface IHome {
    Titulo: string
    , Subtitulo: string
    , Imagen_1: string
    , Ingreso_1: string
    , Tamanio_Imagen_1: string
    , Separador: string
    , Imagen_2: string
    , Ingreso_2: string
    , Tamanio_Imagen_2: string
}

export const slidesOptionsValidClient = {
    init: true
    , initialSlide: 0
    , centeredSlides: true
    , speed: 300
    , effect: 'slide'
    , allowTouchMove: false
    , touchMoveStopPropagation: true
    , preventClicksPropagation: true
    , autoHeight: true
    , observer: true
    , updateOnWindowResize: true
    , resizeObserver: true
}

export const slidesOptionsSegment = {
    init: true
    , initialSlide: 0
    , centeredSlides: true
    , speed: 300
    , effect: 'slide'
    , allowTouchMove: false
    , touchMoveStopPropagation: false
    , preventClicksPropagation: true
    , passiveListeners: false
    , autoHeight: true
    , observer: true
    , updateOnWindowResize: true
    , resizeObserver: true
    , virtual: {
        cache: true
    }
}

export const slidesOptionsImages = {
    init: true
    , initialSlide: 0
    , centeredSlides: true
    , speed: 300
    , effect: 'slide'
    , allowTouchMove: false
    , touchMoveStopPropagation: true
    , preventClicksPropagation: true
    , autoHeight: true
    , observer: true
    , updateOnWindowResize: true
    , virtual: {
        cache: true
    }
}

export const slidesOptionsMoved = {
    init: true
    , initialSlide: 0
    , slidesPerView: 1.05
    , spaceBetween: 0
    , centeredSlides: false
    , speed: 400
    , effect: 'slide'
    , allowTouchMove: true
    , touchMoveStopPropagation: false
    , preventClicksPropagation: true
    , passiveListeners: false
    , autoHeight: true
    , observer: true
    , updateOnWindowResize: true
    , resizeObserver: true
};

export const slidesOptionsMural = {
    init: true
    , initialSlide: 0
    , centeredSlides: true
    , speed: 300
    , effect: 'slide'
    , allowTouchMove: false
    , touchMoveStopPropagation: false
    , preventClicksPropagation: true
    , passiveListeners: false
    , autoHeight: true
    , observer: true
    , updateOnWindowResize: true
    , resizeObserver: true
    , virtual: {
        cache: true
    }
};

export const SECTIONS = {
    HOME: 'Home',
    LOGIN: 'Login',
    CART: 'Cart',
    JUEGOS: 'Juegos',
    TIENDA: 'Tienda',
    PERFIL: 'Perfil',
    MAS: 'Mas',
    HISTORIAL: 'Historial',
    PARA_TI: 'Para Ti',
    MIS_PEDIDOS: 'Mis Pedidos',
    RECOMPEPSI: 'Recompepsi',
    AUTOEVALUACION: 'Autoevaluacion',
    NOTIFICACIONES: 'Notificaciones',
    ENFRIADORES: 'Enfriadores',
    ASISTENCIA: 'Centro Asistencia',
    CRECE_MAS: 'Crece Mas',
    IMPULSA_GEPP: 'Impulsa GEPP',
    LEGALES: 'Legales',
    MAS_SOBRE_GEPP: 'Contenido Cliente',
    EMPTY: '',
    CONFIRMACION: 'Thankyou page',
    ACTIVIDAD: 'Mi actividad',
    CONTACTO: 'Contacto',
    CALIFICA: 'Califica',
    PROGRAMA: 'Programa',
    CAMBIOS_PRODUCTO: 'Cambios Producto',
    REGISTRO: 'Registro',
    RESET_USER: 'Reseteo Usuario'

} as const;

// Analytics page_view URL mapping
export const PAGE_VIEW_URL_MAP: { [key: string]: any } = {
    '/home': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.welcomeView, section: SECTIONS.HOME },
    '/login': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.loginView, section: SECTIONS.LOGIN },
    '/Carrito': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.cartView, section: SECTIONS.CART },
    '/ResumenPedido': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.resumenPedidoView, section: SECTIONS.ACTIVIDAD },
    '/Confirmacion': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.confirmacionPedidoView, section: SECTIONS.CONFIRMACION },
    '/perfil': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.perfilView, section: SECTIONS.PERFIL },
    '/Juegos': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.juegosView, section: SECTIONS.JUEGOS },
    '/MisPedidos': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.misPedidosView, section: SECTIONS.ACTIVIDAD },
    '/Contacto': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.contactLineView, section: SECTIONS.CONTACTO },
    '/Califica': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.rateUsView, section: SECTIONS.CALIFICA },
    '/Impulsa-GEPP': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.boostGeppView, section: SECTIONS.IMPULSA_GEPP },
    '/main/Centro-Asistencia': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.assistanceCenterView, section: SECTIONS.ASISTENCIA },
    '/Cambios-Producto': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.marketChangeView, section: SECTIONS.CAMBIOS_PRODUCTO },
    '/Enfriadores': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.coolersView, section: SECTIONS.ENFRIADORES },
    '/main/Compras': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.shoppingHistoryView, section: SECTIONS.HISTORIAL },
    '/main/ProgramaRecomPepsi': { event: AnalyticsEventType.PAGE_VIEW, ...EAnalyticsPageViews.recompepsiView, section: SECTIONS.RECOMPEPSI },
};


export const slidesOptionsGames = {
    init: true
    , initialSlide: 0
    , slidesPerView: 1.5
    , spaceBetween: 0
    , centeredSlides: true
    , loop: false
    , rewind: true
    , speed: 400
    , effect: 'slide'
    , allowTouchMove: true
    , zoom: false
    , touchMoveStopPropagation: false
    , passiveListeners: false
    , preventClicksPropagation: true
    , observer: true
    , autoHeight: true
    , updateOnWindowResize: true
};

export const PAGINATION_DEFAULTS: any = {
    el: '.swiper-pagination',
    type: 'bullets',
    bulletElement: 'span',
    dynamicBullets: false,
    dynamicMainBullets: 1,
    hideOnClick: false,
    clickable: true,
    progressbarOpposite: false,
    formatFractionCurrent: (number: number) => number,
    formatFractionTotal: (number: number) => number,
    renderBullet: null,
    renderFraction: null,
    renderProgressbar: null,
    renderCustom: null,
    bulletClass: 'swiper-pagination-bullet',
    bulletActiveClass: 'swiper-pagination-bullet-active',
    modifierClass: 'swiper-pagination-',
    currentClass: 'swiper-pagination-current',
    totalClass: 'swiper-pagination-total',
    hiddenClass: 'swiper-pagination-hidden',
    progressbarFillClass: 'swiper-pagination-progressbar-fill',
    clickableClass: 'swiper-pagination-clickable',
    lockClass: 'swiper-pagination-lock',
    horizontalClass: 'swiper-pagination-horizontal',
    verticalClass: 'swiper-pagination-vertical',
    paginationDisabledClass: 'swiper-pagination-disabled',
    progressbarOppositeClass: 'swiper-pagination-progressbar-opposite'
};
export const PAGINATION_SIMPLE: any = {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
    bulletActiveClass: 'swiper-pagination-bullet-active',
    clickableClass: 'swiper-pagination-clickable',
};
export const slidesPromosMoved: any = {
    init: true
    , initialSlide: 0
    , slidesPerView: 1.1
    , spaceBetween: 0
    , centeredSlides: false
    , loop: false
    , loopAdditionalSlides: 0
    , speed: 400
    , effect: 'slide'
    , allowTouchMove: true
    , zoom: false
    , touchMoveStopPropagation: false
    , passiveListeners: false
    , preventClicksPropagation: true
    , observer: true
    , autoHeight: true
    , updateOnWindowResize: true
    , pagination: PAGINATION_SIMPLE
};

export const slidesCatsMoved = {
    init: true
    , initialSlide: 0
    , slidesPerView: 'auto'
    , spaceBetween: 8
    , centeredSlides: false
    , loop: false
    , loopAdditionalSlides: 0
    , speed: 400
    , effect: 'slide'
    , allowTouchMove: true
    , zoom: false
    , touchMoveStopPropagation: false
    , passiveListeners: false
    , preventClicksPropagation: true
    , observer: true
    , autoHeight: true
    , updateOnWindowResize: true
};

export const slidesProgram = {
    init: true
    , initialSlide: 0
    , centeredSlides: true
    , speed: 300
    , effect: 'coverflow'
    , allowTouchMove: true
    , touchMoveStopPropagation: false
    , preventClicksPropagation: true
    , passiveListeners: false
    , autoHeight: true
    , observer: true
    , updateOnWindowResize: true
    , resizeObserver: true
    , coverflowEffect: {
        depth: 100,
        modifier: 1,
        rotate: 50,
        scale: 1,
        slideShadows: true,
        stretch: 0,
    },
};

export const slidesLogrosHist = {
    init: true
    , initialSlide: 0
    , slidesPerView: 1.1
    , spaceBetween: 0
    , centeredSlides: false
    , loop: false
    , loopAdditionalSlides: 0
    , speed: 400
    , effect: 'slide'
    , allowTouchMove: true
    , zoom: false
    , touchMoveStopPropagation: false
    , passiveListeners: false
    , preventClicksPropagation: true
    , observer: true
    , autoHeight: true
    , updateOnWindowResize: true
};

export const slidesPremiados: any = {
    init: true
    , initialSlide: 0
    , autoplay: {
        delay: 3000,
        disableOnInteraction: false
    }
    , slidesPerView: 1
    , spaceBetween: 0
    , centeredSlides: true
    , loop: true
    , loopAdditionalSlides: 0
    , speed: 400
    , effect: 'slide'
    , allowTouchMove: true
    , zoom: false
    , touchMoveStopPropagation: false
    , passiveListeners: false
    , preventClicksPropagation: true
    , observer: true
    , autoHeight: true
    , updateOnWindowResize: true
    , virtual: {
        cache: true
    }
    , direction: 'vertical'
};

export const slidesFavsMoved: any = {
    init: true
    , initialSlide: 0
    , slidesPerView: 1
    , spaceBetween: 0
    , centeredSlides: false
    , loop: false
    , loopAdditionalSlides: 0
    , speed: 400
    , effect: 'slide'
    , allowTouchMove: true
    , zoom: false
    , touchMoveStopPropagation: false
    , passiveListeners: false
    , preventClicksPropagation: true
    , observer: true
    , autoHeight: true
    , updateOnWindowResize: true
    , pagination: PAGINATION_DEFAULTS
};

export const AllUserValues = ['usr_genero', 'usr_edad', 'usr_region', 'usr_id', 'usr_bodega', 'usr_programa', 'usr_nivel', 'usr_territorio', 'usr_ruta', 'usr_canal']


export const GTMInteractions: IObjectDataLayerInteraction = {
    retailerClickEvent: { // 2.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'bienvenida',
            data_accion: 'bienvenida',
            data_etiqueta: 'detallista'
        },
        gtmEvent: {
            categoria: 'bienvenida',
            accion: '/bienvenida',
            etiqueta: 'detallista',
            event: 'interacciones'
        }
    },
    consumerClickEvent: { // 2.1 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'bienvenida',
            data_accion: 'bienvenida',
            data_etiqueta: 'consumidor'
        },
        gtmEvent: {
            categoria: 'bienvenida',
            accion: '/bienvenida',
            etiqueta: 'consumidor',
            event: 'interacciones'
        }
    },
    mainBannerClickEvent: { // 2.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'cliente_consumidor',
            data_accion: 'mas_sobre_gepp',
            data_etiqueta: 'banner_principal'
        },
        gtmEvent: {
            categoria: 'cliente_consumidor',
            accion: '/mas_sobre_gepp',
            etiqueta: 'banner_principal',
            event: 'interacciones'
        }
    },
    loginEvent: { // 3.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'login',
            data_accion: 'login',
            data_etiqueta: 'iniciar_sesion'
        },
        gtmEvent: {
            categoria: 'login',
            accion: '/login',
            etiqueta: 'iniciar_sesion',
            event: 'interacciones'
        }
    },
    forgotPasswordEvent: { // 3.1 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'login',
            data_accion: 'login',
            data_etiqueta: 'olvide_mi_contrasena'
        },
        gtmEvent: {
            categoria: 'login',
            accion: '/login',
            etiqueta: 'olvide_mi_contrasena',
            event: 'interacciones'
        }
    },
    registerEvent: { // 3.1 C
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'login',
            data_accion: 'login',
            data_etiqueta: 'registrar'
        },
        gtmEvent: {
            categoria: 'login',
            accion: '/login',
            etiqueta: 'registrar',
            event: 'interacciones'
        }
    },
    acceptUserNotFoundEvent: { // 3.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'login',
            data_accion: 'login_error_usuario_no encontrado',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'login',
            accion: '/login_error_usuario_no encontrado',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    phoneRevoceryPasswordEvent: { // 4.1 A
        fbEvent: {
            event: 'recuperar_contrasena',
            data_categoria: 'recuperar_contrasena_telefono',
            data_accion: 'aceptar',
            data_etiqueta: 'interacciones'
        },
        gtmEvent: {
            categoria: 'interacciones',
            accion: '/recuperar_contrasena',
            etiqueta: 'recuperar_contrasena_telefono',
            event: 'aceptar'
        }
    },
    recoverySMSAcceptEvent: { // 4.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'recuperar_contrasena',
            data_accion: 'recuperar_contrasena_sms',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'recuperar_contrasena',
            accion: '/recuperar_contrasena_sms',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    recoveryPhoneEditEvent: { // 4.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'recuperar_contrasena',
            data_accion: 'recuperar_contrasena_sms',
            data_etiqueta: 'editar_numero_telefonico'
        },
        gtmEvent: {
            categoria: 'recuperar_contrasena',
            accion: '/recuperar_contrasena_sms',
            etiqueta: 'editar_numero_telefonico',
            event: 'interacciones'
        }
    },
    newPasswordAcceptEvent: { // 5.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'recuperar_contrasena',
            data_accion: 'recuperar_contrasena_ingresa_nueva',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'recuperar_contrasena',
            accion: '/recuperar_contrasena_ingresa_nueva',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    newPasswordCancelEvent: { // 5.1 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'recuperar_contrasena',
            data_accion: 'recuperar_contrasena_ingresa_nueva',
            data_etiqueta: 'cancelar'
        },
        gtmEvent: {
            categoria: 'recuperar_contrasena',
            accion: '/recuperar_contrasena_ingresa_nueva',
            etiqueta: 'cancelar',
            event: 'interacciones'
        }
    },
    acceptTermsEvent: { // 6.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'registro',
            data_accion: 'registro_datos_iniciales',
            data_etiqueta: 'acepto_terminos'
        },
        gtmEvent: {
            categoria: 'registro',
            accion: '/registro_datos_iniciales',
            etiqueta: 'acepto_terminos',
            event: 'interacciones'
        }
    },
    initialDataRegisterAcceptEvent: { // 6.1 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'registro',
            data_accion: 'registro_datos_iniciales',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'registro',
            accion: '/registro_datos_iniciales',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    editSMSNumberRegisterEvent: { // 6.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'registro',
            data_accion: 'registro_editar_num_sms',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'registro',
            accion: '/registro_editar_num_sms',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    registerPhoneEditEvent: { // 6.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'registro',
            data_accion: 'registro_validacion_sms',
            data_etiqueta: 'editar_numero_telefonico'
        },
        gtmEvent: {
            categoria: 'registro',
            accion: '/registro_validacion_sms',
            etiqueta: 'editar_numero_telefonico',
            event: 'interacciones'
        }
    },
    seeHistoryEvent: { // 10.1 A, 10.2 B, 11.1 A, 11.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'programa',
            data_accion: 'programa',
            data_etiqueta: 'ver_historial'
        },
        gtmEvent: {
            categoria: 'programa',
            accion: '/programa',
            etiqueta: 'ver_historial',
            event: 'interacciones'
        }
    },
    awardsCatalogProgramEvent: { // 10.1 B, 10.2 A, 11.1 B, 11.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'programa',
            data_accion: 'programa',
            data_etiqueta: 'catalogo_premios'
        },
        gtmEvent: {
            categoria: 'programa',
            accion: '/programa',
            etiqueta: 'catalogo_premios',
            event: 'interacciones'
        }
    },
    knowMechanicEvent: { // 13.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'programa_seguimiento_swipe',
            data_accion: 'programa_cierre',
            data_etiqueta: 'conoce_la_dinamica'
        },
        gtmEvent: {
            categoria: 'programa_seguimiento_swipe',
            accion: '/programa_cierre',
            etiqueta: 'conoce_la_dinamica',
            event: 'interacciones'
        }
    },
    awardsCatalogEvent: { // 14.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'programa_mis_logros',
            data_accion: 'programa_mis_logros',
            data_etiqueta: 'catalogo_premios'
        },
        gtmEvent: {
            categoria: 'programa_mis_logros',
            accion: '/programa_mis_logros',
            etiqueta: 'catalogo_premios',
            event: 'interacciones'
        }
    },
    createNewOrderEvent: { // 16.2 A, 17.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_inicio',
            data_etiqueta: 'realizar_nuevo_pedido'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_inicio',
            etiqueta: 'realizar_nuevo_pedido',
            event: 'interacciones'
        }
    },
    editOrderEvent: { // 17.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_inicio_pedido_en_curso',
            data_etiqueta: 'editar_mi_pedido'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_inicio_pedido_en_curso',
            etiqueta: 'editar_mi_pedido',
            event: 'interacciones'
        }
    },
    deleteOrderEvent: {
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_inicio_pedido_en_curso',
            data_etiqueta: 'eliminar_pedido'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_inicio_pedido_en_curso',
            etiqueta: 'eliminar_pedido',
            event: 'interacciones'
        }
    },
    summaryTicketBackEvent: { // 18.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_resumen_ticket',
            data_etiqueta: 'regresar'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_resumen_ticket',
            etiqueta: 'regresar',
            event: 'interacciones'
        }
    },
    addToCartEvent: { // 19.1 A
        fbEvent: {
            event: 'agregar_carrito',
            data_categoria: 'tienda',
            data_accion: 'tienda_lista_productos',
            data_etiqueta: 'agregar_al_carrito'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_lista_productos',
            etiqueta: 'agregar_al_carrito',
            event: 'agregar_carrito'
        }
    },
    clearCartEvent: { // 19.1 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_lista_productos',
            data_etiqueta: 'vaciar_carrito'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_lista_productos',
            etiqueta: 'vaciar_carrito',
            event: 'interacciones'
        }
    },
    removeProductEvent: { // 19.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_agregar_carrito',
            data_etiqueta: 'remover_del_carrito'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_agregar_carrito',
            etiqueta: 'remover_del_carrito',
            event: 'interacciones'
        }
    },
    clearCartCheckOutEvent: { // 19.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_agregar_carrito',
            data_etiqueta: 'vaciar_carrito'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_agregar_carrito',
            etiqueta: 'vaciar_carrito',
            event: 'interacciones'
        }
    },
    keepBuyingEvent: { // 19.2 C
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_agregar_carrito',
            data_etiqueta: 'seguir_comprando'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_agregar_carrito',
            etiqueta: 'seguir_comprando',
            event: 'interacciones'
        }
    },
    confirmOrderEvent: {
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_agregar_carrito',
            data_etiqueta: ''
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_agregar_carrito',
            etiqueta: '',
            event: 'interacciones'
        }
    },
    removeProductConfirmEvent: { // 20.1 A
        fbEvent: {
            event: 'remover_carrito',
            data_categoria: 'tienda',
            data_accion: 'tienda_remover_producto_carrito',
            data_etiqueta: 'remover_del_carrito_confirmacion'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_remover_producto_carrito',
            etiqueta: 'remover_del_carrito_confirmacion',
            event: 'remover_carrito'
        }
    },
    confirmClearCartEvent: { // 20.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_vaciar_carrito',
            data_etiqueta: 'vaciar_confirmacion'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_vaciar_carrito',
            etiqueta: 'vaciar_confirmacion',
            event: 'interacciones'
        }
    },
    clearCartCancelEvent: { // 20.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_vaciar_carrito',
            data_etiqueta: 'cancelar'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_vaciar_carrito',
            etiqueta: 'cancelar',
            event: 'interacciones'
        }
    },
    confirmEmptyEvent: { // 21.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_salir_carrito',
            data_etiqueta: 'vaciar_confirmacion'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_salir_carrito',
            etiqueta: 'vaciar_confirmacion',
            event: 'interacciones'
        }
    },
    cancelEmptyEvent: { // 21.1 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_salir_carrito',
            data_etiqueta: 'cancelar'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_salir_carrito',
            etiqueta: 'cancelar',
            event: 'interacciones'
        }
    },
    editOrderConfirmEvent: { // 21.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_confirmacion_compra',
            data_etiqueta: 'editar_mi_pedido'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_confirmacion_compra',
            etiqueta: 'editar_mi_pedido',
            event: 'interacciones'
        }
    },
    backHomeStoreConfirmEvent: { // 21.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_confirmacion_compra',
            data_etiqueta: 'volver_al_inicio'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_confirmacion_compra',
            etiqueta: 'volver_al_inicio',
            event: 'interacciones'
        }
    },
    seePresaleTicketEvent: { // 22.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'historial',
            data_accion: 'historial_compras',
            data_etiqueta: 'consulta_ticket_preventa'
        },
        gtmEvent: {
            categoria: 'historial',
            accion: '/historial_compras',
            etiqueta: 'consulta_ticket_preventa',
            event: 'interacciones'
        }
    },
    seeTicketEvent: { // 22.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'historial',
            data_accion: 'historial_compras',
            data_etiqueta: ''
        },
        gtmEvent: {
            categoria: 'historial',
            accion: '/historial_compras',
            etiqueta: '',
            event: 'interacciones'
        }
    },
    presaleTicketClickEvent: { // 23.1 A, 23.1 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'eticket_preventa',
            data_etiqueta: ''
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/eticket_preventa',
            etiqueta: '',
            event: 'interacciones'
        }
    },
    closeNewsDetailEvent: { // 25.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'feed_noticias',
            data_accion: 'feed_noticias_detalle',
            data_etiqueta: 'cerrar'
        },
        gtmEvent: {
            categoria: 'feed_noticias',
            accion: '/feed_noticias_detalle',
            etiqueta: 'cerrar',
            event: 'interacciones'
        }
    },
    closePromoDetailEvent: { // 26.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'feed_promos',
            data_accion: 'feed_promos_detalle',
            data_etiqueta: 'cerrar'
        },
        gtmEvent: {
            categoria: 'feed_promos',
            accion: '/feed_promos_detalle',
            etiqueta: 'cerrar',
            event: 'interacciones'
        }
    },
    changePasswordEvent: { // 26.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'mi_perfil',
            data_accion: 'perfil_edicion',
            data_etiqueta: 'cambiar_contrasena'
        },
        gtmEvent: {
            categoria: 'mi_perfil',
            accion: '/perfil_edicion',
            etiqueta: 'cambiar_contrasena',
            event: 'interacciones'
        }
    },
    changePhoneEvent: { // 26.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'mi_perfil',
            data_accion: 'perfil_edicion',
            data_etiqueta: 'cambiar_telefono'
        },
        gtmEvent: {
            categoria: 'mi_perfil',
            accion: '/perfil_edicion',
            etiqueta: 'cambiar_telefono',
            event: 'interacciones'
        }
    },
    acceptProfileEvent: { // 26.2 C
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'mi_perfil',
            data_accion: 'perfil_edicion',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'mi_perfil',
            accion: '/perfil_edicion',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    profileEditPassEvent: { // 27.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'mi_perfil',
            data_accion: 'perfil_edicion_contrasena',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'mi_perfil',
            accion: '/perfil_edicion_contrasena',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    profileEditPhoneEvent: { // 27.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'mi_perfil',
            data_accion: 'perfil_edicion_telefono',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'mi_perfil',
            accion: '/perfil_edicion_telefono',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    nextProfilePreEditionPassEvent: { // 29.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'mi_perfil',
            data_accion: 'perfil_pre_edicion_contrasena',
            data_etiqueta: 'siguiente'
        },
        gtmEvent: {
            categoria: 'mi_perfil',
            accion: '/perfil_pre_edicion_contrasena',
            etiqueta: 'siguiente',
            event: 'interacciones'
        }
    },
    nextProfilePreEditionPhoneEvent: { // 29.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'mi_perfil',
            data_accion: 'perfil_pre_edicion_telefono',
            data_etiqueta: 'siguiente'
        },
        gtmEvent: {
            categoria: 'mi_perfil',
            accion: '/perfil_pre_edicion_telefono',
            etiqueta: 'siguiente',
            event: 'interacciones'
        }
    },
    profileEditSMSEvent: { // 30.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'mi_perfil',
            data_accion: 'perfil_edicion_sms',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'mi_perfil',
            accion: '/perfil_edicion_sms',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    sendRateUsEvent: { // 30.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'calificanos',
            data_accion: 'calificanos',
            data_etiqueta: 'enviar'
        },
        gtmEvent: {
            categoria: 'calificanos',
            accion: '/calificanos',
            etiqueta: 'enviar',
            event: 'interacciones'
        }
    },
    rateUsCallEvent: { // 30.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'calificanos',
            data_accion: 'calificanos',
            data_etiqueta: 'numero_telefonico'
        },
        gtmEvent: {
            categoria: 'calificanos',
            accion: '/calificanos',
            etiqueta: 'numero_telefonico',
            event: 'interacciones'
        }
    },
    acceptThanksRateUsEvent: { // 31.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'calificanos',
            data_accion: 'calificanos_gracias',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'calificanos',
            accion: '/calificanos_gracias',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    contactLineCallEvent: { // 31.2 A, 31.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'linea_de_contacto',
            data_accion: 'linea_contacto',
            data_etiqueta: ''
        },
        gtmEvent: {
            categoria: 'linea_de_contacto',
            accion: '/linea_contacto',
            etiqueta: '',
            event: 'interacciones'
        }
    },
    notificationClickEvent: { // 32.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'notificaciones',
            data_accion: 'notificaciones',
            data_etiqueta: ''
        },
        gtmEvent: {
            categoria: 'notificaciones',
            accion: '/notificaciones',
            etiqueta: '',
            event: 'interacciones'
        }
    },
    executionPhotoMenuHamburguerEvent: { // 48.1 A MENU LATERAL Foto de exito
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'menu_lateral',
            data_accion: '',
            data_etiqueta: 'foto_de_exito'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'menu_lateral',
            accion: '',
            etiqueta: 'foto_de_exito',
        }
    },
    executionPhotoMenuMoreEvent: { // 48.1 A MENU MAS Foto de exito
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'menu',
            data_accion: 'menu_mas',
            data_etiqueta: 'foto_de_exito'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'menu',
            accion: '/menu_mas',
            etiqueta: 'foto_de_exito',
        }
    },
    notificationPhotoAcceptEvent: { // 48.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'fotos_exito',
            data_accion: '',
            data_etiqueta: 'tomar fotos'
        },
        gtmEvent: {
            categoria: 'fotos_exito',
            accion: '',
            etiqueta: 'tomar fotos',
            event: 'interacciones'
        }
    },
    notificationPhotoDenyEvent: { // 48.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'fotos_exito',
            data_accion: '',
            data_etiqueta: 'no,ahora'
        },
        gtmEvent: {
            categoria: 'fotos_exito',
            accion: '',
            etiqueta: 'no,ahora',
            event: 'interacciones'
        }
    },
    takePhotosEvent: { // 49.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'fotos_exito',
            data_accion: '/ejecucion_menu',
            data_etiqueta: 'tomar_fotos'
        },
        gtmEvent: {
            categoria: 'fotos_exito',
            accion: '/ejecucion_menu',
            etiqueta: 'tomar_fotos',
            event: 'interacciones'
        }
    },
    helpClickHistoryEvent: { // 55.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'historial',
            data_accion: 'historial_compras',
            data_etiqueta: 'ayuda'
        },
        gtmEvent: {
            categoria: 'historial',
            accion: '/historial_compras',
            etiqueta: 'ayuda',
            event: 'interacciones'
        }
    },
    acceptNewNoticeEvent: { // 55.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'aviso_actualizacion_terminos',
            data_accion: 'aviso_actualizacion_terminos',
            data_etiqueta: 'acepto_aviso_privacidad'
        },
        gtmEvent: {
            categoria: 'aviso_actualizacion_terminos',
            accion: '/aviso_actualizacion_terminos',
            etiqueta: 'acepto_aviso_privacidad',
            event: 'interacciones'
        }
    },
    acceptNewTermsEvent: { // 55.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'aviso_actualizacion_terminos',
            data_accion: 'aviso_actualizacion_terminos',
            data_etiqueta: 'acepto_terminos'
        },
        gtmEvent: {
            categoria: 'aviso_actualizacion_terminos',
            accion: '/aviso_actualizacion_terminos',
            etiqueta: 'acepto_terminos',
            event: 'interacciones'
        }
    },
    acceptNewTermsAndNoticeEvent: { // 55.2 C
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'aviso_actualizacion_terminos',
            data_accion: 'aviso_actualizacion_terminos',
            data_etiqueta: 'aceptar'
        },
        gtmEvent: {
            categoria: 'aviso_actualizacion_terminos',
            accion: '/aviso_actualizacion_terminos',
            etiqueta: 'aceptar',
            event: 'interacciones'
        }
    },
    acceptUserUnregisterEvent: { // 56.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'registra_cuenta_como_nueva',
            data_accion: 'registra_cuenta_como_nueva',
            data_etiqueta: 'entendido'
        },
        gtmEvent: {
            categoria: 'registra_cuenta_como_nueva',
            accion: '/registra_cuenta_como_nueva',
            etiqueta: 'entendido',
            event: 'interacciones'
        }
    },
    acceptUserDisabledEvent: { // 57.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'cuenta_inhabilitada',
            data_accion: 'cuenta_inhabilitada',
            data_etiqueta: 'entendido'
        },
        gtmEvent: {
            categoria: 'cuenta_inhabilitada',
            accion: '/cuenta_inhabilitada',
            etiqueta: 'entendido',
            event: 'interacciones'
        }
    },
    howWorksPromoEvent: { // 57.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda_listado_promociones',
            data_accion: 'tienda_listado_promociones',
            data_etiqueta: 'como_funciona'
        },
        gtmEvent: {
            categoria: 'tienda_listado_promociones',
            accion: '/tienda_listado_promociones',
            etiqueta: 'como_funciona',
            event: 'interacciones'
        }
    },
    wantItPromoEvent: { // 57.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda_listado_promociones',
            data_accion: 'tienda_listado_promociones',
            data_etiqueta: 'lo_quiero'
        },
        gtmEvent: {
            categoria: 'tienda_listado_promociones',
            accion: '/tienda_listado_promociones',
            etiqueta: 'lo_quiero',
            event: 'interacciones'
        }
    },
    howWorksPromoStaticEvent: { // 58.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'modal_como_funciona',
            data_accion: 'tienda_listado_promociones',
            data_etiqueta: 'como_funciona_promo_estatica'
        },
        gtmEvent: {
            categoria: 'modal_como_funciona',
            accion: '/tienda_listado_promociones',
            etiqueta: 'como_funciona_promo_estatica',
            event: 'interacciones'
        }
    },
    helpPromosEvent: { // 58.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda_promocion_estatica',
            data_accion: 'tienda_promocion_estatica',
            data_etiqueta: 'ayuda'
        },
        gtmEvent: {
            categoria: 'tienda_promocion_estatica',
            accion: '/tienda_promocion_estatica',
            etiqueta: 'ayuda',
            event: 'interacciones'
        }
    },
    cancelStaticPromoEvent: { // 58.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda_promocion_estatica',
            data_accion: 'tienda_promocion_estatica',
            data_etiqueta: 'cancelar'
        },
        gtmEvent: {
            categoria: 'tienda_promocion_estatica',
            accion: '/tienda_promocion_estatica',
            etiqueta: 'cancelar',
            event: 'interacciones'
        }
    },
    cartUpdatedPromoStaticEvent: { // 59.1 A
        fbEvent: {
            event: 'incidencia',
            data_categoria: 'tienda_promocion_estatica',
            data_accion: 'tienda_promocion_estatica',
            data_etiqueta: 'carrito_actualizado'
        },
        gtmEvent: {
            categoria: 'tienda_promocion_estatica',
            accion: '/tienda_promocion_estatica',
            etiqueta: 'carrito_actualizado',
            event: 'incidencia'
        }
    },
    howWorksPromoDynamicEvent: { // 59.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'modal_como_funciona',
            data_accion: 'tienda_listado_promociones',
            data_etiqueta: 'como_funciona_promo_dinamica'
        },
        gtmEvent: {
            categoria: 'modal_como_funciona',
            accion: '/tienda_listado_promociones',
            etiqueta: 'como_funciona_promo_dinamica',
            event: 'interacciones'
        }
    },
    cancelDynamicPromoEvent: {
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda_promocion_dinamica',
            data_accion: 'tienda_promocion_dinamica',
            data_etiqueta: 'cancelar'
        },
        gtmEvent: {
            categoria: 'tienda_promocion_dinamica',
            accion: '/tienda_promocion_dinamica',
            etiqueta: 'cancelar',
            event: 'interacciones'
        }
    },
    nextLevelPromoDynamicEvent: { // 60.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda_promocion_dinamica',
            data_accion: 'tienda_promocion_dinamica',
            data_etiqueta: 'siguiente'
        },
        gtmEvent: {
            categoria: 'tienda_promocion_dinamica',
            accion: '/tienda_promocion_dinamica',
            etiqueta: 'siguiente',
            event: 'interacciones'
        }
    },
    updateDynamicPromoEvent: { // 61.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda_promocion_dinamica',
            data_accion: 'tienda_promocion_dinamica',
            data_etiqueta: 'actualizar'
        },
        gtmEvent: {
            categoria: 'tienda_promocion_dinamica',
            accion: '/tienda_promocion_dinamica',
            etiqueta: 'actualizar',
            event: 'interacciones'
        }
    },
    cartUpdatedPromoDynamicEvent: { // 61.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda_promocion_dinamica',
            data_accion: 'tienda_promocion_dinamica',
            data_etiqueta: 'carrito_actualizado'
        },
        gtmEvent: {
            categoria: 'tienda_promocion_dinamica',
            accion: '/tienda_promocion_dinamica',
            etiqueta: 'carrito_actualizado',
            event: 'interacciones'
        }
    },
    cancelStairPromoEvent: {
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda_promocion_escalera',
            data_accion: 'tienda_promocion_escalera',
            data_etiqueta: 'cancelar'
        },
        gtmEvent: {
            categoria: 'tienda_promocion_escalera',
            accion: '/tienda_promocion_escalera',
            etiqueta: 'cancelar',
            event: 'interacciones'
        }
    },
    helpCameraExecutionEvent: { // 63.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'fotos_exito',
            data_accion: 'ejecucion_foto',
            data_etiqueta: 'ayuda'
        },
        gtmEvent: {
            categoria: 'fotos_exito',
            accion: '/ejecucion_foto',
            etiqueta: 'ayuda',
            event: 'interacciones'
        }
    },
    addSuggestedCartEvent: { // 64.1 A
        fbEvent: {
            event: 'agregar_carrito',
            data_categoria: 'tienda_pedido_sugerido',
            data_accion: 'pedido_sugerido',
            data_etiqueta: 'agregar_al_carrito'
        },
        gtmEvent: {
            categoria: 'tienda_pedido_sugerido',
            accion: '/pedido_sugerido',
            etiqueta: 'agregar_al_carrito',
            event: 'agregar_carrito'
        }
    },
    addSuggestedCartMessageEvent: { // 64.2 A
        fbEvent: {
            event: 'incidencia',
            data_categoria: 'tienda',
            data_accion: 'tienda_lista_productos',
            data_etiqueta: 'pedido_sugerido_agregado'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_lista_productos',
            etiqueta: 'pedido_sugerido_agregado',
            event: 'incidencia'
        }
    },
    addCartCouldInterestEvent: { // 64.1 B
        fbEvent: {
            event: 'agregar_carrito',
            data_categoria: 'tienda',
            data_accion: 'tienda_lista_productos',
            data_etiqueta: 'agregar_al_carrito'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_lista_productos',
            etiqueta: 'agregar_al_carrito',
            event: 'agregar_carrito'
        }
    },
    clickBannerSuggestedOrderEvent: { // 64.1 C
        fbEvent: {
            event: 'promoclic',
            data_categoria: 'tienda',
            data_accion: 'tienda_lista_productos',
            data_etiqueta: 'banner_pedido_sugerido'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_lista_productos',
            etiqueta: 'banner_pedido_sugerido',
            event: 'promoclic'
        }
    },
    addToCartInterestProductsEvent: { // 65.1 A
        fbEvent: {
            event: 'agregar_carrito',
            data_categoria: 'tienda_pedido_sugerido',
            data_accion: 'te_puede_interesar',
            data_etiqueta: 'agregar_al_carrito'
        },
        gtmEvent: {
            categoria: 'tienda_pedido_sugerido',
            accion: '/te_puede_interesar',
            etiqueta: 'agregar_al_carrito',
            event: 'agregar_carrito'
        }
    },
    notNowButtonEvent: { // 65.1 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda_pedido_sugerido',
            data_accion: 'te_puede_interesar',
            data_etiqueta: 'no_por_ahora'
        },
        gtmEvent: {
            categoria: 'tienda_pedido_sugerido',
            accion: '/te_puede_interesar',
            etiqueta: 'no_por_ahora',
            event: 'interacciones'
        }
    },
    helpMenuExecutionEvent: { // Por Definir
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'fotos_exito',
            data_accion: 'ejecucion_menu',
            data_etiqueta: 'ayuda'
        },
        gtmEvent: {
            categoria: 'fotos_exito',
            accion: '/ejecucion_menu',
            etiqueta: 'ayuda',
            event: 'interacciones'
        }
    },
    sendPhotosExecutionEvent: { // Por Definir
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'fotos_exito',
            data_accion: 'ejecucion_foto',
            data_etiqueta: 'enviar_foto'
        },
        gtmEvent: {
            categoria: 'fotos_exito',
            accion: '/ejecucion_foto',
            etiqueta: 'enviar_foto',
            event: 'interacciones'
        }
    },
    cancelClearCartEvent: {
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_vaciar_carrito',
            data_etiqueta: 'cancelar'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_vaciar_carrito',
            etiqueta: 'cancelar',
            event: 'interacciones'
        }
    },
    confirmOrderBackEvent: {
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_confirmacion_compra',
            data_etiqueta: 'atras'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_confirmacion_compra',
            etiqueta: 'atras',
            event: 'interacciones'
        }
    },
    clearCartConfirmEvent: {
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'tienda',
            data_accion: 'tienda_vaciar_carrito',
            data_etiqueta: 'vaciar_confirmacion'
        },
        gtmEvent: {
            categoria: 'tienda',
            accion: '/tienda_vaciar_carrito',
            etiqueta: 'vaciar_confirmacion',
            event: 'interacciones'
        }
    },
    registerCompleteEvent: { // N/A
        fbEvent: {
            event: 'incidencia',
            data_categoria: 'exitoso',
            data_accion: '',
            data_etiqueta: 'registro_exitoso'
        },
        gtmEvent: {
            categoria: 'exitoso',
            accion: '/',
            etiqueta: 'registro_exitoso',
            event: 'incidencia'
        }
    },
    phoneExcededRegisterEvent: { // N/A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'errores_registro',
            data_accion: 'registro_error_Intentos excedidos',
            data_etiqueta: 'numero_telefonico'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'errores_registro',
            accion: '/registro_error_Intentos excedidos',
            etiqueta: 'numero_telefonico',
        }
    },
    gamesTitleEvent: { // Gamification 2.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'cabecera',
            data_accion: '',
            data_etiqueta: 'juegos'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'cabecera',
            accion: '',
            etiqueta: 'juegos',
        }
    },
    gamesMenuHamburguerEvent: { // Gamification 2.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'menu_lateral',
            data_accion: '',
            data_etiqueta: 'juegos'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'menu_lateral',
            accion: '',
            etiqueta: 'juegos',
        }
    },
    gamesMenuMoreEvent: { // Gamification 3.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'menu',
            data_accion: 'menu_mas',
            data_etiqueta: 'juegos'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'menu',
            accion: '/menu_mas',
            etiqueta: 'juegos',
        }
    },
    playNewSectionEvent: { // Gamification 3.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'juegos',
            data_accion: 'juegos_bienvenida',
            data_etiqueta: 'a jugar'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'juegos',
            accion: '/juegos_bienvenida',
            etiqueta: 'a jugar',
        }
    },
    playLaterNewSectionEvent: { // Gamification 3.2 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'juegos',
            data_accion: 'juegos_bienvenida',
            data_etiqueta: 'mas tarde'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'juegos',
            accion: '/juegos_bienvenida',
            etiqueta: 'mas tarde',
        }
    },
    playGameEvent: { // Gamification 4.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'juegos | ',
            data_accion: 'juegos_inicio',
            data_etiqueta: 'jugar'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'juegos | ',
            accion: '/juegos_inicio',
            etiqueta: 'jugar',
        }
    },
    redirectLeaderbordGamesEvent: { // Gamification 4.1 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'juegos',
            data_accion: 'juegos_inicio',
            data_etiqueta: 'tablero de posiciones'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'juegos',
            accion: '/juegos_inicio',
            etiqueta: 'tablero de posiciones',
        }
    },
    backErrorGamesEvent: { // Gamification 5.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'juegos',
            data_accion: 'error_actualizacion_juegos',
            data_etiqueta: 'regresar'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'juegos',
            accion: '/error_actualizacion_juegos',
            etiqueta: 'regresar',
        }
    },
    retryErrorGamesEvent: { // Gamification 5.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'juegos',
            data_accion: 'error_conexion_juegos',
            data_etiqueta: 'reintentar'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'juegos',
            accion: '/error_conexion_juegos',
            etiqueta: 'reintentar',
        }
    },
    playDailyLifesEvent: { // Gamification 6.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'juegos',
            data_accion: 'recompensa_diaria',
            data_etiqueta: 'ir a jugar'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'juegos',
            accion: '/recompensa_diaria',
            etiqueta: 'ir a jugar',
        }
    },
    playLaterDailyLifesEvent: { // Gamification 6.1 B
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'juegos',
            data_accion: 'recompensa_diaria',
            data_etiqueta: 'mas tarde'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'juegos',
            accion: '/recompensa_diaria',
            etiqueta: 'mas tarde',
        }
    },
    playFirstLifesEvent: { // Gamification 6.2 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'juegos',
            data_accion: 'obsequio_vidas',
            data_etiqueta: 'a jugar'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'juegos',
            accion: '/obsequio_vidas',
            etiqueta: 'a jugar',
        }
    },
    closeZeroLifesEvent: { // Gamification 7.1 A
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'juegos',
            data_accion: 'sin_vidas',
            data_etiqueta: 'entendido'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'juegos',
            accion: '/sin_vidas',
            etiqueta: 'entendido',
        }
    },
    assistanceCenterMenuHamburguerEvent: { // 2.1 A MENU LATERAL Centro de asistencia
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'menu_lateral',
            data_accion: '',
            data_etiqueta: 'centro de asistencia'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'menu_lateral',
            accion: '',
            etiqueta: 'centro de asistencia',
        }
    },
    assistanceCenterPhotoMenuMoreEvent: { // 2.1 B MENU MAS Centro de asistencia
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'menu',
            data_accion: 'menu_mas',
            data_etiqueta: 'centro de asistencia'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'menu',
            accion: '/menu_mas',
            etiqueta: 'centro de asistencia',
        }
    },
    sendAssistanceEvent: { // 2.1 B Enviar Centro de asistencia
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'asistencia',
            data_accion: 'centro_asistencia',
            data_etiqueta: 'enviar'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'asistencia',
            accion: '/centro_asistencia',
            etiqueta: 'enviar',
        }
    },
    smsCodeInvalidEvent: { // 1.0 Codigo SMS no valido
        fbEvent: {
            event: 'incidencia',
            data_categoria: 'incidencia',
            data_accion: 'registro_perfil',
            data_etiqueta: 'error_registro_codigo_invalido_sms'
        },
        gtmEvent: {
            event: 'incidencia',
            categoria: 'incidencia',
            accion: '/registro_perfil',
            etiqueta: 'error_registro_codigo_invalido_sms',
        }
    },
    profilePhoneAlreadyRegisteredEvent: { // 1.1 Telefono ya registrado perfil
        fbEvent: {
            event: 'incidencia',
            data_categoria: 'mi_perfil',
            data_accion: 'perfil_edicion',
            data_etiqueta: 'cambiar_telefono_existente'
        },
        gtmEvent: {
            event: 'incidencia',
            categoria: 'mi_perfil',
            accion: '/perfil_edicion',
            etiqueta: 'cambiar_telefono_existente',
        }
    },
    phonePermissionEvent: { // 1.2 Permiso telefono
        fbEvent: {
            event: 'incidencia',
            data_categoria: 'bienvenida',
            data_accion: 'bienvenida',
            data_etiqueta: 'permiso_telefono'
        },
        gtmEvent: {
            event: 'incidencia',
            categoria: 'bienvenida',
            accion: '/bienvenida',
            etiqueta: 'permiso_telefono',
        }
    },
    errorSendOrderEvent: { // 1.3 Error procesar pedido
        fbEvent: {
            event: 'incidencia',
            data_categoria: 'tienda',
            data_accion: 'tienda_agregar_carrito',
            data_etiqueta: 'no_pudimos_procesar_pedido'
        },
        gtmEvent: {
            event: 'incidencia',
            categoria: 'tienda',
            accion: '/tienda_agregar_carrito',
            etiqueta: 'no_pudimos_procesar_pedido',
        }
    },
    boostGeppHeaderEvent: { // Impulsa Gepp 1.1
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'cabecera',
            data_accion: '',
            data_etiqueta: 'impulsa'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'cabecera',
            accion: '',
            etiqueta: 'impulsa',
        }
    },
    boostGeppMenuMoreEvent: { // Impulsa Gepp 1.2
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'menu_lateral',
            data_accion: '',
            data_etiqueta: 'impulsa'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'menu_lateral',
            accion: '',
            etiqueta: 'impulsa',
        }
    },
    boostGeppMenuHamburguerEvent: { // Impulsa Gepp 1.3
        fbEvent: {
            event: 'interacciones',
            data_categoria: 'menu_lateral',
            data_accion: '',
            data_etiqueta: 'impulsa'
        },
        gtmEvent: {
            event: 'interacciones',
            categoria: 'menu_lateral',
            accion: '',
            etiqueta: 'impulsa',
        }
    },
    addUpdateSuggestedOrderEvent: { // Pedido sugerido
        gtmEvent: {
            event: 'interacciones',
            categoria: 'tienda',
            accion: '',
            etiqueta: '',
        }
    },
    readMoreSuggestedOrderEvent: { // Pedido sugerido
        gtmEvent: {
            event: 'interacciones',
            categoria: 'tienda',
            accion: '/pedido_sugerido',
            etiqueta: '',
        }
    },
    addRemoveSuggestedOrderEvent: { // Pedido sugerido
        gtmEvent: {
            event: 'interacciones',
            categoria: 'tienda',
            accion: '/pedido_sugerido',
            etiqueta: '',
        }
    },
    addtoCartOrderEvent: { // Pedido sugerido
        gtmEvent: {
            event: 'interacciones',
            categoria: 'tienda',
            accion: '/pedido_sugerido',
            etiqueta: 'agregar_al_carrito',
        }
    },
    addUpdateMostSelledCloseEvent: { // +3
        gtmEvent: {
            event: 'interacciones',
            categoria: 'tienda',
            accion: '',
            etiqueta: '',
        }
    },
    readMoreMostSelledCloseEvent: { // +3
        gtmEvent: {
            event: 'interacciones',
            categoria: 'tienda',
            accion: '/lo_mas_vendido_cerca_de_ti',
            etiqueta: '',
        }
    },
    addRemoveMostSelledCloseEvent: { // +3
        gtmEvent: {
            event: 'interacciones',
            categoria: 'tienda',
            accion: '/lo_mas_vendido_cerca_de_ti',
            etiqueta: '',
        }
    },
    addtoCartMostSelledCloseEvent: { // +3
        gtmEvent: {
            event: 'interacciones',
            categoria: 'tienda',
            accion: '/lo_mas_vendido_cerca_de_ti',
            etiqueta: 'agregar_al_carrito',
        }
    },
    addRemovePromotionEvent: {
        gtmEvent: {
            event: 'interacciones',
            categoria: 'tienda',
            accion: '',
            etiqueta: '',
        }
    },
}

export const GTMEcommerceEvents = {
    viewItemList: 'view_item_list',
    viewPromotion: 'view_promotion',
    selectPromotion: 'select_promotion',
    addToCart: 'add_to_cart',
    removeFromCart: 'remove_from_cart',
    beginCheckout: 'begin_checkout',
    purchase: 'purchase'
}

export const GTMPromotionsEcommerce = {
    suggestedOrder: {
        location_id: '/tienda_lista_productos',
        creative_slot: 'header',
        creative_name: 'slider_pedido_sugerido',
        promotion_id: '1_1',
        promotion_name: 'Pedido sugerido'
    },
    mostSelledClose: {
        location_id: '/tienda_lista_productos',
        creative_slot: 'inline',
        creative_name: 'slider_lo_mas_vendido_cerca_de_ti',
        promotion_id: '1_2',
        promotion_name: 'Lo más vendido cerca de ti'
    },
    promotions: {
        location_id: '/tienda_lista_productos',
        creative_slot: 'inline',
        creative_name: 'slider_promociones',
        promotion_id: '1_3',
        promotion_name: 'Promociones'
    }
}

export const GTMBanners: IObjecBanner = {
    orderSuggestedBannerClick: {
        fbBanner: {
            creative_name: 'banner_pedido_sugerido',
            creative_slot: 'banner_pedido_sugerido_1',
            location_id: '1_1',
            promotion_id: '1',
            promotion_name: 'pedido sugerido'
        },
        gtmBanner: {
            name: 'pedido sugerido',
            id: '1',
            creative: 'banner_pedido_sugerido',
            position: '1_1'
        }
    },
    orderSuggestedBannerView: {
        fbBanner: {
            creative_name: 'banner_pedido_sugerido',
            creative_slot: 'banner_pedido_sugerido_1',
            location_id: '1_1',
            promotion_id: '1',
            promotion_name: 'pedido sugerido'
        },
        gtmBanner: {
            name: 'pedido sugerido',
            id: '1',
            creative: 'banner_pedido_sugerido',
            position: '1_1'
        }
    }
}

export const EventInteraction = ['data_categoria', 'data_accion', 'data_etiqueta']
export const EventEcommerceInteraction = ['currency', 'item_name', 'item_list', 'item_category', 'item_id', 'item_brand', 'price']
export const BannerInteraction = ['creative_name', 'creative_slot', 'location_id', 'promotion_id', 'promotion_name']

export const AllRoutesAnalytics = {
    '/ProgramaCDG': 'programa',
    '/ProgramaGJ': 'programa',
    '/ProgramaSG': 'programa',
    '/Compras': 'historial_compras',
    '/Portafolio': 'portafolio',
    '/Califica': 'calificanos',
    '/TerminoPrograma': 'programa_cierre',
    '/MisPedidos': 'mis_pedidos',
    '/Mas': 'menu_mas',
    '/Mural': 'para_ti',
    '/CreceMas': 'crece_negocio',
    '/Crece-Mas': 'crece_negocio',
    '/Mecanica': 'programa_dinamica',
    '/Contacto': 'linea_contacto',
    '/Notificationes': 'notificaciones',
    '/Historico': 'programa_mis_logros',
    '/perfil': 'perfil_edicion',
    '/ticket-preventa': 'eticket_preventa',
    '/ticket-entrega': 'eticket_entrega',
    '/Tienda': 'tienda_lista_productos',
    '/Carrito': 'tienda_agregar_carrito',
    '/ResumenPedido': 'tienda_resumen_ticket',
    '/Autoevaluacion': 'autoevaluacion',
    '/Noticias': 'noticias',
    '/Centro-Asistencia': 'centro_asistencia',
    '/Juegos': 'juegos',
    '/Load-Game': 'juegos_carga',
    '/Leaderboard': 'ranking',
    '/CancelarCuenta': 'cancelar_cuenta',
    '/ResultadoEjecucion': 'resultado_ejecucion',
    '/Impulsa-GEPP': 'impulsa_gepp',
    '/Promociones': 'promociones',
    '/Orden': 'orden_confirmacion',
    '/TokenExpirado': 'token_expirado',
    '/Recomendados': 'recomendados',
    '/PedidoInteligente': 'pedido_inteligente',
    '/Enfriadores': 'enfriadores',
    '/ProgramaRecomPepsi': 'programa_recompepsi',
    '/Camera-Preview': 'camera_preview',
    '/main/ProgramaCDG': 'programa',
    '/main/ProgramaGJ': 'programa',
    '/main/ProgramaSG': 'programa',
    '/main/Compras': 'historial_compras',
    '/main/Portafolio': 'portafolio',
    '/main/Promociones': 'promociones',
    '/main/Califica': 'calificanos',
    '/main/TerminoPrograma': 'programa_cierre',
    '/main/Tienda': 'tienda_lista_productos',
    '/main/Mas': 'menu_mas',
    '/main/Mural': 'para_ti',
    '/main/CreceMas': 'crece_negocio',
    '/main/Centro-Asistencia': 'centro_asistencia',
    '/main/Impulsa-GEPP': 'impulsa_gepp',
    '/main/Autoevaluacion': 'autoevaluacion',
    '/main/Enfriadores': 'enfriadores',
    '/main/ProgramaRecomPepsi': 'programa_recompepsi',
}

export const DefaultAnalyticsRoute = 'feed_todo'

export const MaxSliceProductsAnalytics = 30;

export const STATUS: IStatus[] = [
    {
        class: 'point',
        dateField: 'fecha_registrado_estatus',
        iconDisabled: 'iconos/registeredDisabled.svg',
        iconEnabled: 'iconos/registeredEnabled.svg',
        title: 'Registrado',
        titleColor: 'medium',
        urlIcon: 'iconos/registeredDisabled.svg'
    },
    {
        class: 'point',
        dateField: 'fecha_despacho_estatus',
        iconDisabled: 'iconos/packOffDisabled.svg',
        iconEnabled: 'iconos/packOffEnabled.svg',
        title: 'Despachando',
        titleColor: 'medium',
        urlIcon: 'iconos/packOffDisabled.svg'
    },
    {
        class: 'point',
        dateField: 'fecha_ruta_estatus',
        iconDisabled: 'iconos/onRouteDisabled.svg',
        iconEnabled: 'iconos/onRouteEnabled.svg',
        title: 'En Ruta',
        titleColor: 'medium',
        urlIcon: 'iconos/onRouteDisabled.svg'
    }
]

export const minWidthDesktop = 576;

export const SummaryPriceDefault: ISummaryPrice = { total_cajas: 0, total_precio: 0, precio_descuento: 0, FactorCl: 0, puntos_recompepsi: 0 };

export const FormPreRegister = ['nud', 'bodega', 'phone'];

export const KEYS_COUNTERS = {
    sms: 'SMS',
    reseteo: 'Reseteo'
}

export const LEVEL_COUNTER_SMS = {
    '1': 3,
    '2': 5,
    '3': 1440
}

export const POP_UPS = {
    promotionPopUp: 1
}